"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2025.08.18.)
 * RTL 2021 API (2025.08.18.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TvProgramByProgDaysFromJSON = TvProgramByProgDaysFromJSON;
exports.TvProgramByProgDaysFromJSONTyped = TvProgramByProgDaysFromJSONTyped;
exports.TvProgramByProgDaysToJSON = TvProgramByProgDaysToJSON;
exports.TvProgramByProgDaysToJSONTyped = TvProgramByProgDaysToJSONTyped;
const runtime_1 = require("../runtime");
const _1 = require("./");
function TvProgramByProgDaysFromJSON(json) {
    return TvProgramByProgDaysFromJSONTyped(json, false);
}
function TvProgramByProgDaysFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'progDays': !(0, runtime_1.exists)(json, 'progDays') ? undefined : (json['progDays'].map(_1.TvProgramProgDaysFromJSON)),
        'logoUrl': !(0, runtime_1.exists)(json, 'logoUrl') ? undefined : json['logoUrl'],
    };
}
function TvProgramByProgDaysToJSON(value) {
    return TvProgramByProgDaysToJSONTyped(value, false);
}
function TvProgramByProgDaysToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'progDays': value.progDays === undefined ? undefined : (value.progDays.map(_1.TvProgramProgDaysToJSON)),
        'logoUrl': value.logoUrl,
    };
}
